<template>
  <div>
    <flipbook class="flipbook" :pages="imageUrls" v-slot="flipbook" ref="flipbook" @flip-left-start="onFlipLeftStart"
      @flip-left-end="onFlipLeftEnd" @flip-right-start="onFlipRightStart" @flip-right-end="onFlipRightEnd">
      <div class="action-bar">
        <v-btn class="mx-2" fab dark small color="primary" :class="{ disabled: !flipbook.canFlipLeft }"
          @click="flipbook.flipLeft">
          <v-icon dark>
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <v-btn class="mx-2" fab dark small color="primary" :class="{ disabled: !flipbook.canZoomIn }"
          @click="flipbook.zoomIn">
          <v-icon dark>
            mdi-plus
          </v-icon>
        </v-btn>
        <span class="page-num">
          Page {{ flipbook.page }} of {{ flipbook.numPages }}
        </span>
        <v-btn class="mx-2" fab dark small color="primary" :class="{ disabled: !flipbook.canZoomOut }"
          @click="flipbook.zoomOut">
          <v-icon dark>
            mdi-minus
          </v-icon>
        </v-btn>
        <v-btn class="mx-2" fab dark small color="primary" :class="{ disabled: !flipbook.canFlipRight }"
          @click="flipbook.flipRight">
          <v-icon dark>
            mdi-chevron-right
          </v-icon>
        </v-btn>
      </div>
    </flipbook>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPage: 1,
      startPage: 1,
      endPage: 26,
      options: {
        width: 400,
        height: 200,
      },
    };
  },
  computed: {
    imageUrls() {
      const pages = [];
      for (let i = this.startPage; i <= this.endPage; i++) {
        const formattedPage = i.toString().padStart(2, '0');
        pages.push(require(`@/assets/kalender2024/${formattedPage}.jpg`));
      }
      return pages;
    },
  },
  methods: {
    onFlipLeftStart(page) {
      console.log('flip-left-start', page)
    },
    onFlipLeftEnd(page) {
      console.log('flip-left-end', page)
      window.location.hash = '#' + page
    },
    onFlipRightStart(page) {
      console.log('flip-right-start', page)
    },
    onFlipRightEnd(page) {
      console.log('flip-right-end', page)
      window.location.hash = '#' + page
    },
  },
  mounted() {
    window.addEventListener('keydown', (ev) => {
      const flipbook = this.$refs.flipbook
      if (!flipbook) return
      if (ev.keyCode == 37 && flipbook.canFlipLeft) flipbook.flipLeft()
      if (ev.keyCode == 39 && flipbook.canFlipRight) flipbook.flipRight()
    })
  }
};
</script>

<style>
.flipbook {
  width: 100vw;
  height: 85vh;
  margin-bottom:100px ;
}

.action-bar {
  width: 100%;
  height: 50px;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-bar .btn {
  font-size: 30px;
  color: #999;
}

.action-bar .btn svg {
  bottom: 0;
}

.action-bar .btn:not(:first-child) {
  margin-left: 10px;
}

.has-mouse .action-bar .btn:hover {
  color: #ccc;
  filter: drop-shadow(1px 1px 5px #000);
  cursor: pointer;
}

.action-bar .btn:active {
  filter: none !important;
}

.action-bar .btn.disabled {
  color: #666;
  pointer-events: none;
}

.action-bar .page-num {
  font-size: 12px;
  margin-left: 10px;
}

.bounding-box {
  border: 1px solid #bbb;
}
</style>
